export default __webpack_public_path__ + "static/media/filter.a06a0d26.svg";